const isEmailInvalid = (email) => {
    const emailRegex = /^([A-z0-9_.]{2,})([@]{1})([A-z]{1,})([.]{1})([A-z.]{1,})*$/;         // Regex for email, name and number validation
    if (!email) return true
    else if ( !email.match(emailRegex) ) {
        return true
    }
    return false
}

const isFullnameInvalid = (name) => {
    const nameRegex = /^([a-zA-Z ]{2,})*$/;                                                      // Regex for email, name and number validation
    if ( !name) return true
    else if ( !name.match(nameRegex) ) return true
    return false
}

const isNameInvalid = (name) => {
    const nameRegex = /^([A-z]{2,})*$/;                                                      // Regex for email, name and number validation
    if ( !name) return true
    else if ( !name.match(nameRegex) ) return true
    return false
}

const isPhoneNumberInvalid = (phone) => {
    const phoneNumberRegex = /^([0-9]{10})*$/;                                               // Regex for email, name and number validation
    if ( !phone ) return true
    else if ( !phone.match(phoneNumberRegex) ) return true
    return false
}

const isFieldInvalid = field => {
    if (!field) return true
    return false
}

function displayErrorSpan (error, errorSpan) {
    if (error === true) errorSpan.removeClass("invisible")
    else errorSpan.addClass("invisible")
}

const toggleSubmitBtn = (submitButton, enableDisableFlag) => {
    submitButton.disabled = enableDisableFlag
    submitButton.style.cursor = enableDisableFlag ? 'not-allowed' : 'pointer'
}

const isCaptchaInvalid = (captchaValue, formId = null) => {
    if (!captchaValue) return true
    
    // Try to find the CAPTCHA input in the specific form
    let captchaInput, num1Element, num2Element
    
    if (formId) {
        // Look within specific form
        const form = document.querySelector(`#${formId}`)
        if (!form) return true
        captchaInput = form.querySelector('#captcha')
        num1Element = form.querySelector('#num1')
        num2Element = form.querySelector('#num2')
    } else {
        // Fallback to global search
        captchaInput = document.querySelector('#captcha')
        num1Element = document.querySelector('#num1')
        num2Element = document.querySelector('#num2')
    }
    
    if (!num1Element || !num2Element) return true
    
    const num1 = parseInt(num1Element.textContent || 0)
    const num2 = parseInt(num2Element.textContent || 0)
    const correctAnswer = num1 + num2
    return parseInt(captchaValue) !== correctAnswer
}

const areFormFieldsValid = (inputId, formId = null) => {
    switch(inputId) {
        case 'firstName':
            return !isNameInvalid( $("#firstName").val())
        case 'lastName':
            return !isNameInvalid( $("#lastName").val())
        case 'fullName':
            return !isFullnameInvalid( $("#fullName").val())
        case 'country':
            return  !isFieldInvalid( $("#country").val())
        case 'city':
            return !isFieldInvalid( $("#city").val())
        case 'state':
            return  !isFieldInvalid( $("#state").val())
        case 'address':
            return !isFieldInvalid( $("#address").val())
        case 'email':
            return  !isEmailInvalid( $("#email").val())
        case 'phone':
            return !isPhoneNumberInvalid( $("#phone").val())
        case 'consent':
            return $("#consent:checked").val() !== undefined
        case 'message':
            return !isFieldInvalid( $("#message").val())
        case 'captcha':
            return !isCaptchaInvalid( $("#captcha").val(), formId)
    }
    return true
}

//auto expand textarea
const adjustTextArea = (h) => {
    h.style.height = "20px"
    h.style.height = (h.scrollHeight)+"px"
}

export {isEmailInvalid, isNameInvalid, isFullnameInvalid, isPhoneNumberInvalid, isFieldInvalid, isCaptchaInvalid, displayErrorSpan, toggleSubmitBtn, areFormFieldsValid, adjustTextArea}